/**
 * FloatingBanner
 * 全ページ共通の「開催中イベント」フローティングバナー。
 * 閉じたら sessionStorage に記録し、同一セッション中は再表示しない。
 */
const STORAGE_KEY = 'eventBannerClosed';

export default class FloatingBanner {
  constructor() {
    this.banner = document.querySelector('.js-floatingBanner');
    if (!this.banner) return;

    this.closeBtn = this.banner.querySelector('.js-floatingBanner-close');

    // セッション内で閉じ済みなら表示しない
    if (this.isClosed()) {
      this.banner.classList.add('is-closed');
      return;
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }
  }

  isClosed() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  }

  close() {
    this.banner.classList.add('is-closed');
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // sessionStorage 不可の環境では無視
    }
  }
}
